import React from 'react';

import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';

import HomeInsuranceMarketplaceFilter from '../components/HomeInsuranceMarketplaceFilter';
import Label from 'components/form/Label/Label';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';

import './HomeOwnerInsuranceMarketplaceModuleView.scss';
import ZeroState from 'components/ZeroState/ZeroState';

const HomeInsuranceView = props => {
  return (
    <SectionContainer className="new-home-insurance-marketplace padT16 m-padT2">
      <HomeInsuranceMarketplaceFilter {...props} />
      <HomeInsuranceOfferView {...props} />
    </SectionContainer>
  );
};

const HomeInsuranceOfferView = props => {
  if (props.fetching) {
    return <PageLoadingMask description="Retrieving Offers" />;
  }
  return <HomeInsuranceOfferContainer {...props} />;
};

const HomeInsuranceOfferContainer = props => {
  return (
    <>
      <Row className="margB16">
        <div>
          <Label type="H6 bold">{`${
            props.insuranceResponse
              ? props.insuranceResponse.items?.length
              : '0'
          } Results`}</Label>
        </div>
      </Row>
      <Row>
        {props?.insuranceResponse?.items?.length > 0 ? (
          <FlexContainer className="flex-column">
            <StaticOfferContainer
              eventHandler={props.eventHandler}
              offerMetadataList={
                props.insuranceResponse ? props.insuranceResponse.items : null
              }
              pagePosition={props.pagePosition}
              modulePosition={props.modulePosition}
              {...props}
            />
          </FlexContainer>
        ) : (
          <ZeroState />
        )}
      </Row>
    </>
  );
};

export default HomeInsuranceView;
